"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var DomainEditor = /** @class */ (function (_super) {
    __extends(DomainEditor, _super);
    function DomainEditor(props) {
        return _super.call(this, props) || this;
    }
    DomainEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    DomainEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    is_locked: _item.is_locked,
                    description: _item.description,
                    domain_template: _item.domain_template,
                    order_number_key: _item.order_number,
                    order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.order_number,
                    order_number_avail: this.getPriorityAvail(),
                    app_country_id: _item.app_country_id,
                    app_country_title: _item.app_country_title,
                    domain_type_code: _item.domain_type_code,
                    domain_type_title: _item.domain_type_title
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование домена"]);
                });
            }
        }
        else {
            this.setState({
                brand_id: 0,
                brand_title: "",
                is_locked: false,
                description: "",
                domain_template: "",
                order_number_key: 1,
                order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                order_number_avail: this.getPriorityAvail(),
                app_country_id: 0,
                app_country_title: "",
                domain_type_code: 0,
                domain_type_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание домена"]);
            });
        }
        this.doReSetRules();
    };
    DomainEditor.prototype.doReSetRules = function () {
        this.setState({
            brand_rules: { isError: false },
            domain_template_rules: { isError: false },
            order_number_rules: { isError: false },
            app_country_rules: { isError: false },
            domain_type_rules: { isError: false }
        });
    };
    DomainEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [брэнд] не выбрано!" } });
            return false;
        }
        if ((this.state.app_country_id <= 0) || (this.state.app_country_title.length === 0)) {
            this.setState({ app_country_rules: { isError: true, errorMessage: "Поле [страна] не выбрано!" } });
            return false;
        }
        if ((this.state.domain_type_code <= 0) || (this.state.domain_type_title.length === 0)) {
            this.setState({ domain_type_rules: { isError: true, errorMessage: "Поле [тип домена] не выбрано!" } });
            return false;
        }
        if ((this.state.order_number_key <= 0) || (this.state.order_number_val.length === 0)) {
            this.setState({ order_number_rules: { isError: true, errorMessage: "Поле [Порядковый номер] не выбрано!" } });
            return false;
        }
        if (this.state.domain_template.length < 10) {
            this.setState({ domain_template_rules: { isError: true, errorMessage: "Поле [шаблон домена] не заполнено, или заполнено некорректно!" } });
            return false;
        }
        //if (this.state.domain_template.indexOf("{0}") < 0) {
        //    this.setState({ domain_template_rules: { isError: true, errorMessage: "Поле [шаблон домена] заполнено некорректно - необходим {0}!" } })
        //    return false;
        //}
        return true;
    };
    DomainEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                description: this.state.description,
                domain_template: this.state.domain_template,
                is_locked: this.state.is_locked,
                order_number: this.state.order_number_key,
                app_country_id: this.state.app_country_id,
                domain_type_code: this.state.domain_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Домен изменен!");
            });
        }
    };
    DomainEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                domain_template: this.state.domain_template,
                brand_id: this.state.brand_id,
                is_locked: this.state.is_locked,
                order_number: this.state.order_number_key,
                app_country_id: this.state.app_country_id,
                domain_type_code: this.state.domain_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Домен добавлен!");
            });
        }
    };
    DomainEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    DomainEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить домен";
        }
        else {
            return "Изменить домен";
        }
    };
    DomainEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Шаблон домена:", placeholder: "Введите шаблон домена" }, value: this.state.domain_template, onValueChanged: function (newVal) {
                    _this.setState({
                        domain_template: newVal,
                        domain_template_rules: { isError: false }
                    });
                }, required: true, rules: this.state.domain_template_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.availBrands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Страна:", placeholder: "Выберите страну" }, value: { key: this.state.app_country_id, value: this.state.app_country_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_country_id: newVal.key,
                        app_country_title: newVal.value,
                        app_country_rules: { isError: false }
                    });
                }, items: this.props.availCountries, required: true, rules: this.state.app_country_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип домена:", placeholder: "Выберите тип домена" }, value: { key: this.state.domain_type_code, value: this.state.domain_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        domain_type_code: newVal.key,
                        domain_type_title: newVal.value,
                        domain_type_rules: { isError: false }
                    });
                }, items: this.props.availDomainTypes, required: true, rules: this.state.domain_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Порядковый номер:", placeholder: "Выберите порядковый номер" }, value: { key: this.state.order_number_key, value: this.state.order_number_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number_key: newVal.key,
                        order_number_val: newVal.value,
                        order_number_rules: { isError: false }
                    });
                }, items: this.state.order_number_avail, required: true, rules: this.state.order_number_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Домен заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return DomainEditor;
}(React.Component));
exports.default = DomainEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_domains_list/ui/component/DomainEditor.tsx
// module id = 2356
// module chunks = 0